import { TextField, Autocomplete } from "@mui/material";
import type { SyntheticEvent } from "react";
import type { KeySelectChangedHandler, KeyValueOption } from "../../../types";

const salesStatus: KeyValueOption[] = [
  { key: 1, value: "平常営業" },
  { key: 2, value: "時間短縮営業" },
  { key: 3, value: "給油制限営業" },
  { key: 4, value: "緊急車両限定営業" },
  { key: 5, value: "営業停止（停電）" },
  { key: 6, value: "営業停止（施設損壊）" },
  { key: 7, value: "営業停止（その他）" },
  { key: 0, value: "不明" },
];

type SalesSelectProps = {
  saleDetailStatus?: number | string | null;
  changedValue: KeySelectChangedHandler;
};

export default function SalesSelect({
  saleDetailStatus,
  changedValue,
}: SalesSelectProps) {
  const handleChange = (
    _event: SyntheticEvent,
    newValues: KeyValueOption | null,
  ) => {
    changedValue(newValues ? newValues.key : null);
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={salesStatus}
      getOptionLabel={(sale) => sale.value}
      isOptionEqualToValue={(option, value) => option.key === value.key}
      value={
        saleDetailStatus != null && saleDetailStatus !== ""
          ? salesStatus.find(
              (status) => status.key === Number(saleDetailStatus)
            ) || null
          : null
      }
      renderInput={(params) => (
        <TextField {...params} name="saleDetailStatusSelect" placeholder="営業状況選択" />
      )}
      onChange={handleChange}
    />
  );
}
